import React from "react";
import Spinner from "../images/preview.gif";
import { FallingLines } from 'react-loader-spinner'

const FullPageLoader = () => {
    return (    
        <div className="fp-container">
            {/* <img src={Spinner} className="fp-loader" alt="loading" /> */}
            <FallingLines
                color="#2F2dF8"
                width="50"
                visible={true}
                ariaLabel='falling-lines-loading'
                />
        </div>
    );
};

export default FullPageLoader;
